import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_3.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/good_hire');
  const shareText = encodeURIComponent('When Good Hires Go Wrong: The Truth About Gut Decisions!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Good Hires — Outstanding Workplaces</title>
        <meta property="og:title" content="Good Hires — Outstanding Workplaces" />
        <meta property="og:description" content="When Good Hires Go Wrong: The Truth About Gut Decisions" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777890442/i_3_pjr3hj.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/good_hire" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Good Hires — Outstanding Workplaces" />
        <meta name="twitter:description" content="When Good Hires Go Wrong: The Truth About Gut Decisions" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777890442/i_3_pjr3hj.jpg" />
      </Helmet>

      <div className="sight_3_page_wrapper">
      <div className="sight_3_content_container">

        <div className="sight_3_section_one">

          {/* TITLE */}
          <h1 className="sight_3_page_title">
            When Good Hires Go Wrong: The Truth About Gut Decisions
          </h1>

          {/* ROW */}
          <div className="sight_3_row">

            {/* LEFT SIDE */}
            <div className="sight_3_left">
              <div className="sight_3_image_wrapper">
                <img
                  src="/assets/i_3.jpg"
                  alt="Team meeting discussion"
                  className="sight_3_blog_image"
                />
              </div>
                {/* SHARE SECTION */}
                <div className="sight_3_share_section">
                  <span className="sight_3_share_text">Share :</span>
                  <div className="sight_3_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_3_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_3_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_3_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_3_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

               <p className="sight_3_intro_paragraph">
                Many companies rely on intuition when hiring developers, but gut feelings often mislead. Even candidates who excel in interviews can underperform on the job. Evidence-based hiring—using data, structured processes, and technical rigor—reduces risk, improves productivity, and transforms hiring from a gamble into a predictable, reliable process.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_3_right">
              <div className="sight_3_ad_card">
                <img src="/assets/bc_1.png" className="sight_3_ad_bg" />
                <div className="sight_3_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_3_ad_badge" />

                <div className="sight_3_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_3_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_3_section">

          <div className="sight_3_topics">

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Why Gut Instinct Fails in Tech Hiring</h2>
              <ul className="sight_3_topic_list">
                <li>Explore why relying on intuition often leads to poor hiring outcomes and how evidence-based approaches improve team performance.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">The Cost of a Bad Hire: Productivity and Beyond</h2>
              <ul className="sight_3_topic_list">
                <li>Discuss how structured assessments, coding tests, and analytics can reduce hiring risks.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Data-Driven Hiring: From Guesswork to Strategy</h2>
              <ul className="sight_3_topic_list">
                <li>Discuss how structured assessments, coding tests, and analytics can reduce hiring risks.</li>
              </ul>
            </div>
            

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Structured Interviews: Making Every Question Count</h2>
              <ul className="sight_3_topic_list">
                <li>Showcase techniques for standardized interviews that objectively measure candidate potential.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Building a High-Performance Team Through Evidence-Based Recruitment</h2>
              <ul className="sight_3_topic_list">
                <li>Illustrate how careful selection impacts overall team efficiency and company culture.</li>
              </ul>
            </div>



            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Balancing Skills and Culture Fit in Developer Hiring</h2>
              <ul className="sight_3_topic_list">
                <li>Examine the tension between technical expertise and alignment with workplace values.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Common Hiring Biases and How to Avoid Them</h2>
              <ul className="sight_3_topic_list">
                <li>Identify cognitive and cultural biases that influence instinctive hiring choices.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Onboarding Matters: When the Right Hire Needs the Right Start</h2>
              <ul className="sight_3_topic_list">
                <li>Show how structured onboarding complements evidence-based hiring to ensure success.</li>
              </ul>
            </div>

            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">Continuous Feedback Loops: Learning From Hiring Outcomes</h2>
              <ul className="sight_3_topic_list">
                <li>Advocate tracking performance post-hire to refine recruitment strategies over time.</li>
              </ul>
            </div>


            <div className="sight_3_topic_item">
              <h2 className="sight_3_topic_heading">From Gamble to Science: Transforming Recruitment in Tech Teams</h2>
              <ul className="sight_3_topic_list">
                <li>A forward-looking piece on integrating analytics, structured evaluation, and technical rigor into hiring processes.</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;




